import { useDataValue, useDataChange, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'referral',
    viewPath: props.viewPath,
  })

  let submitPersons = useDataSubmit({
    context: 'persons',
    viewPath: props.viewPath,
  })

  let person = useDataValue({
    context: 'person',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    change(next => {
      next.person = person
      next.is_patient = 'patient' in person
    })
    submitPersons()
  }
}
